const options = {
  root: null,
  rootMargin: '60px 0px -50px',
  threshold: 0
}

const callback = (entries, observer) => {
  entries.forEach(entry => {
    const elem = entry.target
    if (entry.isIntersecting) {
      elem.isLeaving = true
      elem.dispatchEvent(new CustomEvent(elem.dataset.visibleEvent, { bubbles: true, detail: true }))
    } else if (elem.isLeaving) {
      elem.classList.remove(elem.dataset.completeClass)
      elem.dispatchEvent(new CustomEvent(elem.dataset.hiddenEvent, { bubbles: true, detail: false }))
    }
  })
}

const observer = new IntersectionObserver(callback, options)

const setupInViewEvents = function (elem, visibleEvent, hiddenEvent) {
  elem.dataset.visibleEvent = visibleEvent
  elem.dataset.hiddenEvent = hiddenEvent
  observer.observe(elem)
}

export {
  setupInViewEvents
}
